module.exports = __webpack_public_path__ + "img/earth_cloud.980056a6.png";